const BANNER_LOADING = "BANNER_LOADING";
const BANNER_SUCCESS = "BANNER_SUCCESS";
const BANNER_ERROR = "BANNER_ERROR";

export {
    BANNER_LOADING,
    BANNER_ERROR,
    BANNER_SUCCESS,
};